import Barba from 'barba.js'
import Manager from './Classes/Manager'
import TweenLite from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import mobileNavigation from './scipts/navigation'

// Transitions
import BaseTransition from './Transition/BaseTransition'
import HomepageThemeTransition from './Transition/HomepageThemeTransition'

/**
 * Barba properties setup. Here we set the wrapper id,
 * the wrapper class, the data- namespace attribute
 * name and we disable the barba cache.
 */
Barba.Pjax.Dom.wrapperId = 'app';
Barba.Pjax.Dom.containerClass = 'page-container';
Barba.Pjax.Dom.dataNamespace = 'type';
Barba.Pjax.cacheEnabled = false;
Barba.Pjax.Manager = Manager;
Barba.Pjax.popped = false;

window.addEventListener('popstate', event => {
    Barba.Pjax.popped = true
    Barba.Pjax.lastLink = null
})

document.querySelector('.back-to-top').addEventListener('click', el => {
    TweenLite.to(window, 1, {
        scrollTo: 0
    })
});

Barba.Dispatcher.on('initStateChange', function() {
    // modify to your needs
    if (typeof gtag !== "undefined") {
        gtag('config', 'UA-4035801-7', {
            'anonymize_ip': true,
            'page_title': document.title,
            'page_path': (window.location.href).replace(window.location.origin, '').toLowerCase()
        });
    }
});

/**
 * Cache the current click link element for further
 * logic based on the specific anchor tag.
 */
Barba.Dispatcher.on('linkClicked', (el, event) => {
    Barba.Pjax.lastLink = el;
    Barba.Pjax.popped = false;
    Manager.getVueManager().destroy();
});

/**
 * Remove old page metadata and substitute them with metadata
 * of the new page, if they are present. Plus execute every
 * check that is needed for the correct display of the
 * new page.
 */
Barba.Dispatcher.on('newPageReady', (currentStatus, prevStatus, container, newPage) => {
    Barba.Pjax.pageLoad = !prevStatus.hasOwnProperty('url')
    if (Barba.Pjax.pageLoad) {
        if (matchMedia('(min-width: 768px)').matches) {
            Manager.getAnimationManager().get('loader').play();
        } else {
            document.querySelector('.loader').remove();
            document.querySelector('html').classList.remove('enable-loading');
            Barba.Dispatcher.trigger('pageLoading');
        }
    }
    let parser = new DOMParser();
    let page = parser.parseFromString(newPage, 'text/html');
    let newContentStyles = page.querySelector('#content-styles');
    let oldContentStyles = document.querySelector('#content-styles');

    let newAdditionalAssets = page.querySelectorAll('.additional-asset');
    let oldAdditionalAssets = document.querySelectorAll('.additional-asset');

    if (oldContentStyles) {
        document.head.removeChild(oldContentStyles);
    }

    if (newContentStyles) {
        document.head.appendChild(newContentStyles);
    }

    if (oldAdditionalAssets) {
        oldAdditionalAssets.forEach(e => document.head.removeChild(e));
    }

    if (newAdditionalAssets) {
        newAdditionalAssets.forEach(e => document.head.appendChild(e));
    }

    document.body.classList = page.body.classList;

    document.querySelectorAll('a[href^="#"]').forEach(el => {
        el.addEventListener('click', ev => {
            ev.preventDefault();
            TweenLite.to(window, 1, {
                scrollTo: {y: ev.currentTarget.getAttribute('href'), offsetY: 82}
            })
        })
    })

    if (location.hash && location.hash !== '') {
        setTimeout(() => {
            window.scrollTo(0, 0);
            TweenLite.to(window, 1, {
                scrollTo: {y: location.hash, offsetY: 82}
            })
        }, 1)
    }
})

Barba.Dispatcher.on('transitionCompleted', (currentStatus, prevStatus) => {
    Manager.getVueManager().create();
    document.querySelector('.hamburger').addEventListener('click', mobileNavigation);
    if( Barba.Pjax.AudioPlayer ) {
        Barba.Pjax.AudioPlayer.eventListener();
    }
})

/**
 * The following block of code is used to automatically register barba
 * Views. It will recursively scan this directory for every js file
 * and automatically call their relative init() function on barba.
 *
 * Eg. ./View/Homepage.js -> HomepageView
 */
const files = require.context('./View/', true, /\.js$/i)
files.keys().map(key => files(key).default.init());

Barba.Pjax.getTransition = function () {
    if (Barba.Pjax.lastLink && Barba.Pjax.lastLink.classList.contains('theme-cta')) {
        return HomepageThemeTransition;
    }
    return BaseTransition;
}
Barba.Pjax.start();
